import { GameMetadata } from "@/pages/subs/play/common/game-registry";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export const GameList = ({
  games,
  setSelectedGame,
}: {
  games: GameMetadata[];
  setSelectedGame: (game: GameMetadata) => void;
}) => {
  return (
    <div className="w-full h-full p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-2 text-center">🎮 로컬 게임</h1>
        <p className="text-muted-foreground text-center mb-8">
          같은 기기에서 친구들과 함께 즐길 수 있는 게임들
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {games.map((game) => (
            <Card
              key={game.id}
              className="cursor-pointer hover:shadow-lg transition-shadow border hover:border-primary/50"
              onClick={() => setSelectedGame(game)}
            >
              <CardHeader className="text-center">
                <div className="text-4xl mb-4">{game.icon}</div>
                <CardTitle className="text-xl">{game.name}</CardTitle>
                <CardDescription className="text-sm">
                  {game.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="text-center">
                <Button className="w-full">게임 시작</Button>
              </CardContent>
            </Card>
          ))}
          {games.length === 0 && (
            <div className="col-span-full text-center py-12">
              <p className="text-muted-foreground">
                사용 가능한 로컬 게임이 없습니다.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
